<template>
<div class="container">
    <!--header-->
    <div class="tui-header-box">
        <div class="tui-searchbox" @click="search">
            <van-icon name="search" size="20px" />
            <p class="tui-search-text" v-if="!searchKey">请输入搜索关键词~</p>
            <div class="tui-search-key" v-if="searchKey">
                <div class="tui-key-text">{{ searchKey }}</div>
            </div>
        </div>
        <!--screen-->
        <div class="tui-header-screen">
            <div class="tui-screen-top">
                <div class="tui-top-item tui-icon-ml" data-index="0" @click="screen(0)">
                    <span :class="[tabIndex == 0 ? 'tui-active tui-bold' : '']">价格</span>
                    <img src="../../../static/images/product/sou.png" class="icon-active" v-show="tabIndex != 0" />
                    <img src="../../../static/images/product/souend.png" class="icon-active" v-show="!priceFlag && tabIndex == 0" />
                    <img src="../../../static/images/product/souTop.png" class="icon-active" v-show="priceFlag && tabIndex == 0" />
                </div>
                <div class="tui-top-item tui-icon-ml" data-index="1" @click="screen(1)">
                    <span :class="[tabIndex == 1 ? 'tui-active tui-bold' : '']">销量</span>
                    <img src="../../../static/images/product/sou.png" class="icon-active" v-show="tabIndex != 1" />
                    <img src="../../../static/images/product/souend.png" class="icon-active" v-show="!saleFlag && tabIndex == 1" />
                    <img src="../../../static/images/product/souTop.png" class="icon-active" v-show="saleFlag && tabIndex == 1" />
                </div>
                <div class="tui-top-item tui-icon-ml" data-index="2" @click="screen(2)">
                    <span :class="[tabIndex == 2 ? 'tui-active tui-bold' : '']">好评</span>
                    <img src="../../../static/images/product/sou.png" class="icon-active" v-show="tabIndex != 2" />
                    <img src="../../../static/images/product/souend.png" class="icon-active" v-show="!commentFlag && tabIndex == 2" />
                    <img src="../../../static/images/product/souTop.png" class="icon-active" v-show="commentFlag && tabIndex == 2" />
                </div>
                <div class="tui-top-item tui-icon-ml" data-index="3" @click="screen(3)">
                    <span :class="[tabIndex == 3 ? 'tui-active tui-bold' : '']">时间</span>
                    <img src="../../../static/images/product/sou.png" class="icon-active" v-show="tabIndex != 3" />
                    <img src="../../../static/images/product/souend.png" class="icon-active" v-show="!shelvesFlag && tabIndex == 3" />
                    <img src="../../../static/images/product/souTop.png" class="icon-active" v-show="shelvesFlag && tabIndex == 3" />
                </div>
                <div class="tui-top-item" @click="screen(4)" data-index="4">
                    <img src="../../../static/images/product/pailieSend@2x.png" class="icon-pailie" v-show="!isList" />
                    <img src="../../../static/images/product/pailie@2x.png" class="icon-pailie" v-show="isList" />
                    <span></span>
                </div>
                <div class="tui-top-item tui-icon-ml" @click="screen(5)" data-index="5">
                    <span>筛选</span>
                    <img src="../../../static/images/product/shaixuan-3@2x.png" class="icon-pailie" />
                </div>
            </div>
        </div>
    </div>
    <div style="height: 10px"></div>
    <!--促销描述-->
    <!-- <div class="margin-sm text-sm text-333" v-if="promotionId">
        <span v-if="polymericInfo.frontPromotionType == 6">满额减促销：</span>{{ polymericInfo.description }}
    </div> -->
    <!--商品列表-->
    <van-list :loading="loading" :finished="complated" :total="total" @load="onLoad">
        <productItem :productList="productList" :isList="isList" :isPromotion="promotionId ? true : false" @click="detail"></productItem>
        <div v-if="productList.length <= 0">
            <notData title="暂无相关商品" content="每天都给自己一个惊喜，看看其他商品吧" :img="notImg"></notData>
        </div>
    </van-list>
    <!--左抽屉弹层 筛选 -->
    <van-popup v-model="drawer" position="right" :style="{ height: '100%' }">
        <div class="tui-drawer-box">
            <div class="popup-back">
                <span class="popback" @click="closePopup()"><van-icon name="arrow-left" size="12px" color="#2283E2" @click="closeDrawer" />返回</span>
                <span class="poptitle tui-title-bold">更多筛选</span>
            </div>
            <div class="tui-drawer-scroll">
                <div class="tui-drawer-title">
                    <p class="tui-title-bold">分类筛选</p>
                    <div class="tui-all-box tui-icon-ml">
                    </div>
                </div>
                <div class="tui-drawer-content tui-flex-attr">
                    <div v-for="(item, index) in menuList" :key="index" class="tui-attr-item" :class="{checked:index==n}" @click="menuClick(index,item)">
                        <div class="tui-attr-ellipsis">{{ item.name }}</div>
                    </div>
                </div>
                <div class="tui-drawer-title">
                    <p class="tui-title-bold ">价格区间</p>
                </div>
                <div class="tui-drawer-content">
                    <input placeholder-class="tui-phcolor" class="tui-input" placeholder="最低积分" maxlength="11" type="number" v-model="minPoint" />
                    <div class="middle"></div>
                    <input placeholder-class="tui-phcolor" class="tui-input" placeholder="最高积分" maxlength="11" type="number" v-model="maxPoint" />
                </div>
                 <div class="tui-drawer-content tui-flex-attr">
                    <div v-for="(item, index) in pointList" :key="index" class="tui-attr-item" :class="{checked:index==mn}" @click="count(index,item)">
                        <div class="tui-attr-ellipsis">{{ item.name }}</div>
                    </div>
                </div>

                <!-- <div class="tui-drawer-title">
                    <p class="tui-title-bold">品牌</p>
                    <div class="tui-all-box tui-icon-ml">
                    </div>
                </div>
                <div class="tui-drawer-content tui-flex-attr">
                    <div v-for="(item, index) in brandList" :key="index" class="tui-attr-item" :class="{checked:index==n}" @click="brandClick(index,item)">
                        <div class="tui-attr-ellipsis">{{ item }}</div>
                    </div>
                </div> -->
            </div>
            <div class="tui-attr-btnbox">
                <div class="tui-attr-safearea">
                    <!-- <van-icon name="cross" size="24px" color="#777777" @click="closeDrawer" /> -->
                    <div class="tui-drawer-btn tui-drawerbtn-black" @click="reset">
                        重置
                    </div>
                    <div class="tui-drawer-btn tui-drawerbtn-primary" @click="confirm">
                        确定
                    </div>
                </div>
            </div>
        </div>
    </van-popup>
    <!--左抽屉弹层 筛选-->
    <!-- <div class="product-cart" @click="goCart">
        <span class="cart-num" v-if="cartNum && cartNum > 0">{{ cartNum }}</span>
        <img src="../../../static/images/product/shop.png" />
    </div> -->
    <!-- 回到顶部 -->
  <backtop/>

</div>
</template>

<script>
import wx from "weixin-js-sdk";
import productItem from "@/components/product/productItem.vue";
import notData from "@/components/notData.vue";
import backtop from "@/components/BackTop.vue";

import {
    queryProductBrandAll,
    queryPolymericInfo,
    userCartNum,
    getproductlist,
    totalPoint,
    queryBeforeCategory,
} from "../../api/api";
export default {
    components: {
        productItem,
        notData,
        backtop
    },
    data() {
        return {
            n: -1,//分类
            mn:-1,//价格
            cartNum: "",
            notImg: require("../../../static/images/product/not-product.png"),
            promotionId: "", //是否是促销聚合页
            polymericInfo: [], //促销聚合描述
            priceFlag: false, //价格排序标志
            saleFlag: false, //销量排序标志 added by tzc at 2021-3-10 15:18:46
            commentFlag: false, //评论排序标志 added by tzc at 2021-3-10 15:18:46
            shelvesFlag: false, //上架标志 added by tzc at 2021-3-10 15:18:46
            searchKey: this.$route.query.cName, //搜索关键词
            saleNumFlag: false,
            tabIndex: 0, //顶部筛选索引
            isList: false, //是否以列表展示  | 列表或大图
            drawer: false,
            selectedName: "综合",
            productList: [],
            moneyMin: "",
            moneyMax: "",
            brandList: ["海尔", "卡萨帝", "统帅"],
            arr: [],
            complated: false,
            loading: false,
            finished: false,
            start: 1,
            brandIds: [],
            sortType: 1,
            sortPrice: true,
            sortSaleNum: true,
            cName: "", //分类名称
            brandName: "", //品牌名称
            categoryName: this.$route.query.name, //分类
            chineseName: "", //商品名称
            maxPoint: "", //最大积分
            minPoint: "", //最小积分
            status: "", //排序
            total: 0, //总条数
            pageNum: 1,
            toTop:false, //是否显示回到顶部
            menuList:[],
            pointList: [{
                    name: "5000-1万积分",
                    minPoint: "5000",
                    maxPoint: "10000",
                },
                {
                    name: "1万-3万积分",
                    minPoint: "10001",
                    maxPoint: "30000",
                },
                {
                    name: "3万-5万积分",
                    minPoint: "30001",
                    maxPoint: "50000",
                },
                {
                    name: "5万-10万",
                    minPoint: "50001",
                    maxPoint: "100000",
                },
                {
                    name: "10万-20万",
                    minPoint: "100001",
                    maxPoint: "200000",
                },
                {
                    name: "20万以上",
                    minPoint: "200000",
                    maxPoint: "10000000000000000000000000000000000000",
                },
            ],
        };
    },
    mounted: function (options) {
        // if (this.$route.query.token) {
        //     this.$cookies.set("token", this.$route.query.token);
        // }

        // this.getShow();
        this.userCartNum();
        this.productListInit(1);
        this.queryBeforeCategory()
        

    },
    methods: {
        // 积分范围查询
        count(index,item){
          this.mn = index;

          this.maxPoint = item.maxPoint;
          this.minPoint = item.minPoint;
        },
        // 初始化类目
        async queryBeforeCategory() {
            let params = {
                id: "1",
                isVisible: 1,
            };
            let res = await queryBeforeCategory(params);
            if (res.code == "0000") {
                this.menuList = res.data[0].categoryList;
            }
        },
        //接受参数初始化
        productListInit(num) {
            // console.log("num:"+num)
            // 分类
            if (this.$route.query.cName !== undefined) {
                this.cName = this.$route.query.cName;
            }else{
                this.cName=""
            }
            // 分类
            if (this.$route.query.categoryName !== undefined) {
                this.categoryName = this.$route.query.categoryName;
            }else{
                this.categoryName=null
            }

            // 搜索
            if (this.$route.query.chineseName !== undefined) {
                this.chineseName = this.$route.query.chineseName;
            }else{
                this.chineseName =""
            }

            // 品牌
            if (this.$route.query.brandName !== undefined) {
                this.brandName = this.$route.query.brandName;
            }

            // 最大积分
            if (this.$route.query.maxPoint !== undefined) {
                this.maxPoint = this.$route.query.maxPoint;
            }else{
                this.maxPoint = ""
            }

            // 最低积分
            if (this.$route.query.minPoint !== undefined) {
                this.minPoint = this.$route.query.minPoint;
            }else{
                this.minPoint = ""
            }

            // 状态
            if (this.$route.query.status !== undefined) {
                this.status = this.$route.query.status;
            }
            if (num==1) {
                this.productList = []
                this.pageNum=1
                this.classification(1)
            }
            // if (num != 1) this.classification(1);
        },
        //购物车
        goCart: function () {
            wx.miniProgram.switchTab({
                url: "/pages/cart/cart",
            });
        },
        onLoad() {
            if(!this.loading){
                 this.loading = true;//证明正在加载中 阻断 调用onLoad
                 this.classification();//反向loading 没在加载中 可以进入
            }
        },
        screen: function (index) {
            this.start = 1;
            if (index == 0) {
                this.tabIndex = 0;
                this.pageNum = 1;
                this.priceFlag = !this.priceFlag;
                if (!this.priceFlag) {
                    this.status = 1;
                } else {
                    this.status = 2;
                }
                // this.sortPrice = !this.sortPrice;
                this.classification(9);
            } else if (index == 1) {
                this.tabIndex = 1;
                this.pageNum = 1;
                this.saleFlag = !this.saleFlag;
                if (!this.saleFlag) {
                    this.status = 3;
                } else {
                    this.status = 4;
                }
                // this.sortPrice = !this.sortPrice;
                this.classification(9);
            } else if (index == 2) {
                this.tabIndex = 2;
                this.pageNum = 1;
                this.commentFlag = !this.commentFlag;
                if (!this.commentFlag) {
                    this.status = 5;
                } else {
                    this.status = 6;
                }
                // this.sortPrice = !this.sortPrice;
                this.classification(9);
            } else if (index == 3) {
                this.tabIndex = 3;
                this.pageNum = 1;
                this.shelvesFlag = !this.shelvesFlag;
                if (!this.shelvesFlag) {
                    this.status = 7;
                } else {
                    this.status = 8;
                }
                // this.sortPrice = !this.sortPrice;
                this.classification(9);
            } else if (index == 4) {
                this.isList = !this.isList;
            } else if (index == 5) {
                this.pageNum = 1;
                this.drawer = !this.drawer;
                if (this.drawer) {
                    this.queryProductBrandAll();
                }
            }
        },
        closeDrawer: function () {
            this.drawer = false;
        },
        confirm() {
            this.drawer = false;
            this.start = 1;
            this.productList = [];
            this.brandIds = [];
            this.classification(1);
        },
        //重置
        reset() {
            this.drawer = true;
            this.maxPoint = "";
            this.minPoint = "";
            this.brandName = "";
            // this.arr = [];
            this.start = 1;
            this.n = -1;
            this.mn = -1;

            // this.getShow();

            // this.classification(1);
        },
        //搜索
        search: function () {
            this.$router.push({
                path: "/orders/search",
            });
        },
        //选择品牌
        brandClick(index, item) {
            this.n = index;
            // console.log(index,item)
            this.brandName = item;
        },
        //选择类目
        menuClick(index, item) {
            this.n = index;
            // console.log(index,item)
            this.categoryName = item.name;
        },
        detail: function (e) {
            this.$router.push({
                path: "/productDetails?id=" + e,
            });
        },
        // async getShow(param){
        // 	var this_=this;
        // 	var temp;
        // 	if(this.moneyMin>this.moneyMax){
        // 		temp=this.moneyMin;
        // 		this.moneyMin=this.moneyMax
        // 		this.moneyMax=temp;
        // 	}
        // 	const res = await queryRestPorduct({
        // 		chineseName:this.$route.query.searchVal,
        // 		categoryId:this.$route.query.id,
        // 		start:this.start,
        // 		limit:20,
        // 		maxPrice:this.moneyMax,
        // 		minPrice:this.moneyMin,
        // 		brandIds:this.brandIds,
        // 		type:this.sortType,
        // 		promotionId:this.$route.query.promotionId, //促销活动id
        // 		promotionType:this.$route.query.promotionType, //促销活动类型
        // 		});
        // 	if (res.code === "0000" && res.data.rows.length>0) {
        // 		this_.productList=this_.productList.concat(res.data.rows);
        // 		if(res.data.rows.length!=10){
        // 		this_.finished=true;
        // 		}
        // 		this.loading =false;
        // 	} else {
        // 		this.finished=true;
        // 		// this.$toast(res.msg);
        // 	}
        // },

        //商品分类列表
        async classification(nn) {
            // console.log("nn:"+nn)
            let params = {
                //商品id
                id: "",
                //品牌IDs
                // brandIds: this.brandIds,
                //品牌名称
                brandName: this.brandName,
                //分类名称
                categoryName: this.categoryName,
                cName: this.cName,
                //商品名称
                chineseName: this.searchKey,
                //标题
                subtitle: "",
                //积分
                recommendRetailPrice: "",
                //图片url
                pictureUrl: "",
                //最大最小积分
                // moneyMin: this.moneyMin,
                // moneyMax: this.moneyMax,

                //最小积分
                minPoint: this.minPoint,
                //最大积分
                maxPoint: this.maxPoint,
                //分页参数
                pageNum: this.pageNum,
                pageSize: "12",
                //排序
                status: this.status,
                showTerminal:1,
                showDesk:2
            };
            let productRes = await getproductlist(params);//请求查询
            // if (productRes.result.pages < this.pageNum){
            //      this.loading = false;//关闭加载
            //     return false; //查询出的最大页码 如果小于当前页码 证明没数据 跳出！
            // }
            if (productRes.result.pageNum != this.pageNum) { //返回的当前页与传入的当前页不符合 证明存在重复加载的嫌疑 
                this.pageNum = productRes.result.pageNum + 1;
                return false;
            }
            if (productRes.code == "0000") {
                if (nn == 9) this.productList = [];
                this.productList = this.productList.concat(productRes.result.list);//拼接查询结果
                this.total = productRes.result.total;//获取最大条数
                if ((this.pageNum * params.pageSize) > productRes.result.total) {//如果当前页和每页显示条数大于total证明查询结果不够12条 显示没有更多 否则 不显示
                    this.complated = true;
                } else {
                     this.complated = false;
                }
                this.pageNum = this.pageNum + 1;//当前页加一
                this.loading = false;//关闭加载
            }
        },
        //初始化品牌
        async queryProductBrandAll() {
            const res = await queryProductBrandAll({
                start: 1,
                limit: 10,
            });
            if (res.code === "0000" && res.data.rows.length > 0) {
                // this.brandList = res.data.rows;
            }
        },

        //促销聚合页信息
        async getPolymericInfo(promotionId, promotionType) {
            const res = await queryPolymericInfo({
                promotionId: promotionId,
                promotionType: promotionType,
            });
            if (res.code === "0000") {
                this.polymericInfo = res.data;
            }
        },
        // 商品数量
        async userCartNum() {
            const res = await userCartNum();
            if (res.code == "0000") {
                // this.$store.commit("setCartNum", res.data.num);
                this.cartNum = res.data;
            } else {
                this.$toast(res.msg);
            }
        },
    },
    beforeRouteLeave(to,from,next){
      from.meta.top = document.documentElement.scrollTop || document.body.scrollTop;
      next()
    },
    beforeRouteEnter(to, from, next) {
        if(from.path == '/productDetails') {
          to.meta.isBack = true;//是否返回的判断依据改为true
        }
        next();//beforeRouteEnter必须携带
    },
    activated() {
        document.documentElement.scrollTop = document.body.scrollTop =this.$route.meta.top
        if (!this.$route.meta.isBack) {
            this.n = -1;
            this.mn = -1;
            this.productListInit(1);
            this.userCartNum();
            this.queryBeforeCategory()
        }
        //执行完初始化isBack
        this.$route.meta.isBack = false 
    }
};
</script>

<style lang="scss" scoped>
.product-cart {
    position: fixed;
    right: 10px;
    bottom: 200px;
    width: 90px;
    height: 90px;
    background: $theme-color-main;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: 70px;
        height: 70px;
        margin-right: 8px;
    }

    .cart-num {
        background: #ffffff;
        color: $theme-color-main;
        border-radius: 20px;
        padding: 2px 8px;
        font-size: 10px;
        position: absolute;
        right: 10px;
        top: 15px;
    }
}

/deep/.custom-image {
    width: 240px;
    height: 220px;
}

// .container {
//     background-color: #f1f1f1;
// }

.bg-white {
    background: #ffffff;
}

.coupon-icon {
    width: 62px;
    height: 28px;
    margin-right: 10px;
}

.tui-header-box {
    width: 100%;
    background: #fff;
    // position: fixed;
    // z-index: 99998;
    // left: 0;
    // top: 0px;
    padding-top: 10px;
}

.tui-searchbox {
    width: 95%;
    height: 68px;
    border: 2px solid #cbcbcb;
    border-radius: 34px;
    font-size: 28px;
    color: #cbcbcb;
    line-height: 68px;
    padding: 0px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin: 20px;
}

.tui-search-text {
    padding-left: 16px;
}

.tui-search-key {
    /*padding:  20px;*/
    margin-left: 12px;
    display: flex;
    align-items: center;
    /*border-radius: 15px;*/
    /*background: rgba(0, 0, 0, 0.5);*/
    /*color: #fff;*/
}

.tui-key-text {
    box-sizing: border-box;
    padding-right: 12px;
    font-size: 28px;
    line-height: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
}

/*screen*/

.tui-header-screen {
    width: 100%;
    box-sizing: border-box;
    background: #fff;
}

.tui-screen-top,
.tui-screen-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    color: #333;
}

.tui-screen-top {
    height: 88px;
    position: relative;
    background: #fff;
}

.tui-top-item {
    height: 28px;
    line-height: 28px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tui-top-item span {
    margin-right: 10px;
    padding-bottom: 8px;
}

.tui-active {
    color: $theme-color-main;
    border-bottom: 4px solid $theme-color-main;
}

.tui-attr-item.checked {
    background-color: #fff !important;
    color: $theme-color-main;
    font-weight: bold;
    position: relative;
}

.tui-attr-item.checked::after {
    content: "";
    position: absolute;
    border: 2px solid $theme-color-main;
    width: 100%;
    height: 100%;
    border-radius: 40px;
    left: 0;
    top: 0;
}

.tui-drawer-box {
    width: 636px;
    font-size: 24px;
    padding-top: 20px;
}

.tui-drawer-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    height: 80px;
    // border-bottom: 1px solid #ececec;
    margin-left: 20px;
    margin-top: 20px;
}

.tui-title-bold {
    font-size: 28px;
    font-weight: bold;
    flex-shrink: 0;
}

.tui-location {
    margin-right: 6px;
}

.tui-attr-right {
    width: 70%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
}

.tui-all-box {
    width: 90%;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.tui-drawer-content {
    padding: 22px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.popup-back{
     padding: 22px 22px;
    border-bottom: 2px #ececec solid;
    font-size: 28px;

     .popback{
         color: $theme-color-main;
         display: inline-block;
         padding: 10px;
         cursor: pointer;
     }
     .poptitle{
         text-align: center;
         display: inline-block;
         width: 60%;
     }
}
.tui-flex-bottom {
    border-bottom: 30px #ececec solid;
}

.tui-input {
    border: 0;
    width: 250px;
    height: 70px;
    border-radius: 4px;
    background-color: #f7f7f7;
    text-align: center;
    font-size: 24px;
    color: #333;
}

.tui-phcolor {
    text-align: center;
    color: #b2b2b2;
    font-size: 24px;
}

.tui-flex-attr {
    flex-wrap: wrap;
    justify-content: flex-start;
}

px {
    width: 30%;
    height: 64px;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    box-sizing: border-box;
    border-radius: 32px;
    margin-right: 5%;
    margin-bottom: 5%;
}

.tui-attr-ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.tui-attr-btnbox {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 0 1%;
    background: #fff;
}

.tui-attr-safearea {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.tui-attr-btnbox::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    border-top: 1px solid #eaeef1;
    transform: scaleY(0.5) translateZ(0);
    transform-origin: 0 0;
}

.tui-drawer-btn {
    width: 50%;
    height: 80px;
    font-size: 30px;
    text-align: center;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.tui-drawerbtn-black{
    border: 1px solid $theme-color-main;
    color:$theme-color-main
}
.tui-drawerbtn-primary {
    background: $theme-color-main;
    color: #fff;
}

.icon-pailie {
    width: 34px;
    height: 34px;
}

.icon-active {
    width: 20px;
    height: 10px;
}

.tui-attr-item {
    margin-right: 16px;
    margin-bottom: 30px;
    width: 180px;
    height: 68px;
    background: #f1f1f1;
    border-radius: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    // color: #111;
    font-size: 25px;
}

.middle {
    width: 20px;
    height: 1px;
    background: #dbdbdb;
}
</style>
